<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue'
import { isClient} from '@vueuse/core'
import { useRoute, useRouter } from 'vue-router'
import { useAddToCartToastStore } from '~/stores/addToCartToastStore'
import { useIframeStore } from '~/stores/chatAIStore'

const addToCartToast = useAddToCartToastStore()
const router = useRouter();
const route = useRoute();
const iframeMessages = ref<string[]>([]);
const iframeRef = ref<HTMLIFrameElement | null>(null);
const cartQuantity = ref('0');
const iframeStore = useIframeStore();

if (isClient) {
  const storedQuantity = sessionStorage.getItem('cartQuantity');
  if (storedQuantity) {
    cartQuantity.value = storedQuantity;
  }
}

const enableViewCartCta = () => {
    iframeStore.sendMessageToChatbot('addToCartCTA',{
        isMinimized: false,
    })
}

const addToCart = (productId: number | undefined) => {
  if (!!productId) {
    siteService()
      .addToCart(productId)
      .then(() => { 
        addToCartToast.open("success", "Item added to cart!");
        enableViewCartCta();
      })
      .catch(() => addToCartToast.open("error", "Failed to add to cart"));
  } else {
      addToCartToast.open("error", "Failed to add to cart");
  }
};

const handleIframeMessage = (event: MessageEvent) => {
  if (event.data.type === 'FROM_IFRAME') {
    iframeMessages.value.push(event.data.message);
  }
  if (event.data.type === 'REDIRECT_URL') {
    const url = event.data?.url;
    if (url?.startsWith('http://') || url?.startsWith('https://')) {
      const target = new URL(url);
      target.searchParams.set('returnTo', route.fullPath);
      window.location.href = target.toString();

    } else {
      router.push(url).then(() => {
        window.location.reload();
      });
    }
  }
  if (event.data.type === 'ADDTOCART_CLICK') {
    const productId = event.data?.productId;
    if (productId) {
      addToCart(productId);
  }
};
  if (event.data.type === 'triggerMailto') {
      const email = event.data.email;
      window.location.href = `mailto:${email}`;
  }
};

onMounted(() => {
  cartQuantity.value = sessionStorage.getItem('cartQuantity') || '0';
  window.addEventListener('message', handleIframeMessage);
});

onBeforeUnmount(() => {
  window.removeEventListener('message', handleIframeMessage);
});

</script>
